var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 35
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.807.181a.64.64 0 0 0-.676-.138L.407 15.083a.638.638 0 0 0-.082 1.15l8.025 4.522 2.785 13.614a.638.638 0 0 0 1.084.333l6.04-6.056a.638.638 0 0 0-.903-.901l-4.745 4.757 1.025-8.78 14.492 7.953a.637.637 0 0 0 .912-.355L39.963.854a.64.64 0 0 0-.156-.673M2.127 15.784 33.778 3.49 8.894 19.596zm10.585 6.423a.64.64 0 0 0-.236.439l-.885 7.582-1.961-9.587L31.122 6.73zm15.374 7.99-13.85-7.603L37.963 2.648l-9.877 27.548z"
  })));
};
export default SvgTelegram;